
<template>
  <div>
    <div class="text-center mt-3">
      <a href="#" onclick="window.print();return false;"
        ><i class="fa fa-3x fa-print"></i
      ></a>
    </div>
    <div class="row legenda text-right">
      <div class="col-md-12">
        <strong class="text-primary"> Ítens: </strong>{{ qtdItens }}
        <strong class="text-primary">| Produtos: </strong> {{ qtdProdutos }}
        <strong class="text-primary"> | Total: </strong> R$ {{ valorTotal }}
      </div>
    </div>

    <table class="table table-striped table-responsive ml-3">
      <thead>
        <tr>
          <th class="text-center">Código</th>
          <th>Produto</th>
          <th class="text-center">Valor</th>
          <th class="text-center">Quantidade</th>
          <th class="text-center">Total</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(data,index) in tableData" class="text-center" :key="index">
          <td>{{ data.codigo }}</td>
          <td class="text-left">{{ data.nome }}</td>
          <td>{{ data.preco }}</td>
          <td>{{ data.quantidade }}</td>
          <td>{{ data.total }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
export default {
  props: [],
  data() {
    return {
      overflowEstoque: 999999,
      colunas: [
        ["Código", "codigo"],
        ["Produto", "nome"],
        ["Preço R$", "preco"],
        ["Qtd", "quantidade"],
        ["Total R$", "total"],
      ],
      actionsTable: ["edit"],
      estoque: {},
      tableData: [],
      produtos: {},
      quantidade: "",
      codigo: "",
      labelProduto: "",
      currentProduto: 0,
    };
  },
  methods: {
    getProdutos: function () {
      $(".loading").show();
      var vm = this;
      axios
        .get("/distribuidor/produtos/list")
        .then(function (response) {
          let produtos = response.data;
          produtos.forEach(function (produto) {
            vm.produtos[produto.codigo] = {
              id: produto.id,
              nome: produto.nome,
            };
          });
          $(".loading").hide();
        })
        .catch(function (error) {
          alert("Erro ao carregar Produtos");
          console.log(error);
          $(".loading").hide();
        });
    },
    loadEstoque: function () {
      var vm = this;
      $(".loading").show();

      axios
        .get("/distribuidor/estoque/listar")
        .then(function (response) {
          let estoques = response.data;

          var tableData = [];
          var estoqueLocal = {};
          estoques.forEach(function (estoque) {
            let preco = estoque.preco;
            let total = preco * estoque.quantidade;
            let obj = {
              id: estoque.codigo,
              codigo: estoque.codigo,
              nome: estoque.nome,
              preco: parseFloat(preco).toFixed(2).replace(".", ","),
              quantidade: estoque.quantidade,
              total: total.toFixed(2).replace(".", ","),
            };
            estoqueLocal[estoque.codigo] = estoque.quantidade;
            tableData.push(obj);
          });

          vm.tableData = tableData;
          vm.estoque = estoqueLocal;
          $(".loading").hide();
        })
        .catch(function (error) {
          alert("Erro ao carregar Estoque");
          console.log(error);
          $(".loading").hide();
        });
    },
  },

  computed: {
    qtdItens: function () {
      var total = 0;

      for (var codigo in this.estoque) {
        total += this.estoque[codigo];
      }
      return total;
    },
    qtdProdutos: function () {
      return Object.keys(this.estoque).length;
    },
    valorTotal: function () {
      var total = 0;

      this.tableData.forEach(function (item) {
        total += parseFloat(item.total.replace(",", "."));
      });
      return total.toFixed(2).replace(".", ",");
    },
  },

  created() {
    this.getProdutos();
    this.loadEstoque();
  },
  mounted() {
    $("#input-codigo-produto").focus();
  },
};
</script>

<style scoped="">
.container-btn {
  padding-top: 1.8em;
}
.legenda {
  font-size: 1.3em;
}

@media print {
  body,
  .hidden-print,
  .menu-distribuidor {
    display: none !important;
    height: 0;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/estoque/Imprimir.vue